<template>
  <CSidebar
    fixed
    :breakpoint="false"
    :show="show"
    @update:show="(value) => updateShow(value)"
  >
    <CSidebarBrand>
      <CLink to="/">
        <img
          src="/img/igrain/footer/logo.png"
          class="mb-2"
          style="width: 120px; margin-top: 5px"
        />
      </CLink>
    </CSidebarBrand>
    <CSidebarNav>
      <CSidebarNavItem to="/search" icon="cil-spa" name="Buy grain" />
      <CSidebarNavItem to="/offer" icon="cil-plant" name="Sell grain" />
      <CSidebarNavItem to="/plus">
        <CLink to="/plus" class="c-sidebar-nav-link" target="_self">
          <CIcon name="cil-bar-chart" class="c-sidebar-nav-icon" />
          <span style="font-weight: 700">igrain</span>Plus
          <CBadge color="danger"> NEW </CBadge>
        </CLink>
      </CSidebarNavItem>

      <span v-if="isLoggedIn">
        <span v-for="(section, index) in sections" :key="index">
          <CSidebarNavTitle v-if="section.label">{{
            section.label
          }}</CSidebarNavTitle>
          <CSidebarNavItem
            v-for="(item, itemIndex) in section.items"
            :key="itemIndex"
            :to="item.to"
            :icon="item.icon"
            :name="item.label"
            :badge="{ text: item.badgeLabel, color: item.badgeColor }"
          />
        </span>
      </span>

      <CSidebarNavItem
        v-if="isAdminUser"
        to="/admin"
        icon="cil-speedometer"
        name="Admin"
      />
      <CSidebarNavItem v-if="isLoggedIn">
        <div class="ml-3 mr-3 mb-3 mt-2">
          <CButton @click="logout" color="primary" variant="outline" block
            >Logout</CButton
          >
        </div>
      </CSidebarNavItem>
      <CSidebarNavItem v-if="!isLoggedIn">
        <div class="ml-3 mr-3 mb-3 mt-2">
          <CButton to="/login" color="primary" variant="outline" block
            >Login</CButton
          >
        </div>
      </CSidebarNavItem>
      <CSidebarNavItem v-if="!isLoggedIn">
        <div class="ml-3 mr-3">
          <CButton to="/register" color="primary" block>Register</CButton>
        </div>
      </CSidebarNavItem>
    </CSidebarNav>
    <CSidebarFooter style="text-align: center" v-if="grainOnOffer">
      <strong>{{ grainOnOffer }}</strong> tonnes on offer
    </CSidebarFooter>
  </CSidebar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import metricAPI from '@/api/metric'

export default {
  name: 'Sidebar',
  data() {
    return {
      grainOnOffer: null,
    }
  },
  mounted() {
    this.getMetrics()
  },
  methods: {
    async getMetrics() {
      const result = await metricAPI.listing()
      this.grainOnOffer = Number(result.grainOnOffer.toFixed()).toLocaleString()
    },
    ...mapActions('auth', {
      authLogout: 'logout',
    }),
    logout() {
      this.authLogout()
      this.updateShow(false)
      if (this.$router.currentRoute.path !== '/') this.$router.push('/')
    },
    updateShow(value) {
      this.$store.commit('set', ['sidebarShow', value])
    },
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'isAdminUser']),
    show() {
      return this.$store.state.coreui.sidebarShow
    },
    sections() {
      return this.$store.state.navigation.sections
    },
  },
}
</script>

<style scoped>
.c-sidebar-brand,
.c-sidebar-footer {
  background-color: #163845;
}
.c-sidebar-nav {
  background-color: #1d4b5c;
}
</style>
